module.exports = __webpack_public_path__ + "static/media/bullet-rectangle.feef310f.svg";